import React, { useState, useRef, useEffect } from "react";
import { View, Text, TextInput, StyleSheet, Modal, Image, TouchableOpacity } from "react-native";
import { useTranslation } from 'react-i18next';
import { useSessionStore } from "../../../../../../../state/src/useSessionStore";
import Colors from "../../../../../constants/colors";

type PinInputStepProps = {
  handleForgotPassword?: () => void;
  attemptsLeft?: number;
  locked?: boolean;
  resetSignal?: number; 
};

export default function PinInputStep({ attemptsLeft, locked, handleForgotPassword, resetSignal = 0 }: PinInputStepProps) {
  const { t } = useTranslation();
  const [pin, setPin] = useState(["", "", "", ""]);
  const inputs = useRef<(TextInput | null)[]>([]);
  const setConsumerPin = useSessionStore((s: any) => s.setConsumerPin);

  // 🔑 watch for resetSignal changes
  useEffect(() => {
    setPin(["", "", "", ""]);
    inputs.current[0]?.focus();
  }, [resetSignal]);



  const handleChange = (text: string, index: number) => {
    if (/^\d*$/.test(text)) {
      const newPin = [...pin];
      newPin[index] = text;
      setPin(newPin);
      try { setConsumerPin?.(newPin.join("")); } catch {}

      // Move to next box automatically
      if (text && index < 3) {
        inputs.current[index + 1]?.focus();
      }

      // Backspace handling
      if (!text && index > 0) {
        inputs.current[index - 1]?.focus();
      }
    }
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>{t("PIN_INPUT_TITLE")}</Text>
      <Text style={styles.subtitle}>{t("PIN_INPUT_SUBTITLE")}</Text>

      <View style={styles.pinContainer}>
        {pin.map((digit, index) => (
          <TextInput
            key={index}
            ref={(el) => (inputs.current[index] = el)}
            style={styles.pinInput}
            keyboardType="number-pad"
            maxLength={1}
            secureTextEntry
            value={digit}
            onChangeText={(text) => handleChange(text, index)}
          />
        ))}
      </View>

      {/* {pin.join("").length > 0 && pin.join("").length < 4 && (
        <Text style={styles.error}>{t("PIN_INPUT_ERROR")}</Text>
      )} */}
      {!locked ? (
        <Text style={styles.attempts}>
          {attemptsLeft} {attemptsLeft === 1 ? "attempt" : "attempts"} remaining
        </Text>
      ) : (
        <Text style={styles.locked}>{t("ACCOUNT_LOCKED")}</Text>
      )}
      {/* <Modal
        visible={showPopup}
        transparent
        animationType="slide"
        // onRequestClose={() => setShowPopup(false)}
        onRequestClose={() => handleForgotPassword?.()}
      >
        <View style={styles.modalOverlay}>
          <View style={styles.modalContent}>
            <TouchableOpacity
              onPress={() => handleForgotPassword?.()}
              style={{ alignItems: 'flex-end'}}
            >
            <Image
              source={CloseIcon}
              style={{width: 24, height: 24}}
            />
          </TouchableOpacity>
          <View style={{ alignItems:'center'}}>
            <Image source={AccountLockedIcon} style={{ width: 64, height: 64, marginTop: 48}}/>
            <Text style={styles.accountLock}>
              {t("YOUR_ACCOUNT_LOCKED")}
            </Text>
            <Text style={styles.accountLockInfo}>
              {t("YOU_CAN_CONTINUE_AS_GUEST")}
            </Text>
            <TouchableOpacity
              style={styles.button}
              onPress={() => handleForgotPassword?.()}
            >
              <Text style={styles.buttonText}>
              {t("CONTINUE_AS_GUEST")}
              </Text>
            </TouchableOpacity>
          </View>
          </View>
        </View>
      </Modal> */}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 24,
    justifyContent: "flex-start",
    marginTop: 16,
  },
  title: {
    fontSize: 22,
    fontWeight: "700",
    marginBottom: 6,
    color: "#111827",
  },
  subtitle: {
    fontSize: 14,
    color: "#6B7280",
    marginBottom: 20,
  },
  pinContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  pinInput: {
    width: 60,
    height: 60,
    borderWidth: 1,
    borderColor: "#D1D5DB",
    borderRadius: 12,
    textAlign: "center",
    fontSize: 22,
    fontWeight: "600",
    backgroundColor: "#F9FAFB",
    marginRight: 24
  },
  error: {
    color: "red",
    fontSize: 12,
    marginTop: 8,
  },
  attempts: {
    fontSize: 14,
    color: "#6B7280" },
  locked: {
    fontSize: 14,
    color: "red",
    fontWeight: "700"
  },
  modalOverlay: {
    flex: 1,
    justifyContent: "flex-end",
    backgroundColor: "rgba(0,0,0,0.4)"
  },
  modalContent: {
    backgroundColor: "white", padding: 20,
    borderTopLeftRadius: 20, borderTopRightRadius: 20,
  },
  accountLock: {
    fontSize: 24,
    fontWeight: "500",
    lineHeight: 28,
    fontFamily: 'Rubik',
    marginVertical: 26,
    color: Colors.accountLock,
  },
  accountLockInfo: {
    fontSize: 14,
    fontWeight: "400",
    lineHeight: 18,
    fontFamily: 'Rubik',
    marginBottom: 48,
    color: Colors.accountLock,
  },
  button: {
    backgroundColor: Colors.titleTextColor,
    paddingVertical: 16,
    borderRadius: 8,
    alignItems: "center",
  },
  buttonText: {
    color: Colors.white,
    fontSize: 16,
    fontWeight: "500",
    fontFamily: 'Rubik',
    lineHeight: 20,
    paddingHorizontal: 100
  },
});
